import { objectSpread } from '@polkadot/util';
import { jsonEncryptFormat } from '@polkadot/util-crypto';
export function pairToJson(type, _ref, encoded, isEncrypted) {
  let {
    address,
    meta
  } = _ref;
  return objectSpread(jsonEncryptFormat(encoded, ['pkcs8', type], isEncrypted), {
    address,
    meta
  });
}